import script from "./LateralBar.vue?vue&type=script&setup=true&lang=js"
export * from "./LateralBar.vue?vue&type=script&setup=true&lang=js"

import "./LateralBar.vue?vue&type=style&index=0&id=316b95ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-316b95ca"]])

export default __exports__